export default __webpack_public_path__ + "static/media/ProximaNova-Regular.19c6c7d1.ttf";